import React, { useEffect } from "react";
import "./Services.css";
import adsimg from "../Images/Group 1000001377.png";
import socialmediaimg from "../Images/Group 1000001378.png";
import amazonimg from "../Images/Group 1000001379.png";
import amazonimg2 from "../Images/Group 1000001378 (1).png";
import webimg from "../Images/Group 1000001380.png";
// import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import AOS from "aos"
import 'aos/dist/aos.css'
import Fade from 'react-reveal/Fade';


function Services() {

  // useEffect(() => {
  //   AOS.init({ duration: 2000 })
  // }, [])

  return (
    <div>
      <div className="container-fluid our-service-div1">
        <div className="services-color-svg"></div>
        <div className="services-color-svg2"></div>
        <div className="container">
          <svg
            className="service-section1-svg1"
            width="97"
            height="128"
            viewBox="0 0 97 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 2C34.7632 30.3214 74.0789 23.7857 85 63"
              stroke="url(#paint0_linear_345_297)"
              stroke-width="5"
            />

            <circle cx="87" cy="69" r="8" stroke="#19E7A7" stroke-width="4" />
            <circle
              opacity="0.5"
              cx="33"
              cy="96"
              r="8"
              stroke="#2BAC85"
              stroke-width="4"
            />
            <circle
              opacity="0.5"
              cx="71.5"
              cy="121.5"
              r="5.5"
              stroke="#78FFD6"
              stroke-width="2"
            />
            <defs>
              <linearGradient
                id="paint0_linear_345_297"
                x1="85"
                y1="63"
                x2="-0.499998"
                y2="4.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#18FFB7" />
                <stop offset="1" stop-color="#272727" />
              </linearGradient>
            </defs>
          </svg>

          <div>
            <Fade top distance="4%" duration={1200}>
              <h1 className="our-text1">
                Our
                <svg
                  className="our-text-svg"
                  width="119"
                  height="28"
                  viewBox="0 0 119 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.478378 12.0889C43.5911 16.1899 71.849 -11.916 103.47 13.7183"
                    stroke="url(#paint0_linear_345_66)"
                    stroke-width="5"
                  />
                  <circle
                    cx="108.577"
                    cy="17.4495"
                    r="8"
                    transform="rotate(-35.4072 108.577 17.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_345_66"
                      x1="103.47"
                      y1="13.7183"
                      x2="-0.110795"
                      y2="15.575"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#18FFB7" />
                      <stop offset="1" stop-color="white" />
                    </linearGradient>
                  </defs>
                </svg>
              </h1>
            </Fade>
            <Fade top distance="4%" duration={1200}>
              <h1 className="our-services-text1">Services</h1>
            </Fade>
          </div>
          <svg
            className="service-section1-svg2"
            width="80"
            height="67"
            viewBox="0 0 49 67"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 7.15366C16.3407 0.694396 42.1778 -3.01968 22.8 33.7981C13.1111 53.1759 18 60.5 18 67"
              stroke="url(#paint0_linear_345_301)"
              stroke-width="5"
            />
            <circle cx="-5" cy="10" r="8" stroke="#19E7A7" stroke-width="4" />
            <defs>
              <linearGradient
                id="paint0_linear_345_301"
                x1="30"
                y1="71.043"
                x2="51.544"
                y2="23.4708"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#272727" />
                <stop offset="1" stop-color="#2ED19E" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <div className="container ourservices-list-div ">
          <div className="row justify-content-center mx-auto">
            <Fade top distance="4%" duration={1200}>

              <div className="col-lg-6 col-12 ourservices-list-div2" >
                <div className="row ">
                  <svg
                    className="ourservices-list-svg-1"
                    width="100"
                    height="100"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="50.0788"
                      cy="50.0792"
                      r="47.3121"
                      transform="rotate(-111.759 50.0788 50.0792)"
                      stroke="#414141"
                      stroke-width="4"
                    />
                    <path
                      d="M65.1558 57.2888L65.1445 57.2969L65.1336 57.3054C64.2194 58.0232 62.8912 59.1513 61.7131 60.1519C61.0724 60.696 60.4762 61.2024 60.0151 61.5846C59.7579 61.7978 59.4467 61.8368 59.1643 61.6913C57.443 60.2396 56.8988 59.4266 56.0524 58.1622C55.9052 57.9423 55.7488 57.7087 55.5755 57.4557L55.179 56.8769L54.6868 57.3768C52.9354 59.1554 51.4605 60.2761 49.8933 60.9579C48.3301 61.6379 46.6287 61.9014 44.3916 61.8902C41.7838 61.8772 39.5105 61.0529 37.8962 59.475C36.2862 57.9013 35.2729 55.5207 35.2891 52.2778C35.3144 47.1981 38.0483 43.8519 41.9213 42.1768L41.9219 42.1766C43.6243 41.4383 45.6859 40.9949 47.8172 40.684C49.2542 40.4745 50.6922 40.3288 52.06 40.1903C52.7269 40.1227 53.377 40.0569 54.0023 39.9861L54.5127 39.9283L54.5153 39.4147L54.5193 38.6001C54.5201 38.4329 54.5229 38.2575 54.5258 38.0762C54.5357 37.4518 54.5468 36.7577 54.4829 36.0891C54.3994 35.2168 54.1845 34.3081 53.6291 33.5245C52.6834 32.1324 51.0014 31.5622 49.5544 31.5549C48.2088 31.5482 46.9063 31.8795 45.8563 32.6029C44.801 33.33 44.0317 34.4335 43.7358 35.9026C43.6747 36.1361 43.5772 36.3394 43.4654 36.4729C43.3678 36.5894 43.2853 36.6263 43.2131 36.632L37.0447 35.9446C36.8618 35.8854 36.7167 35.8017 36.631 35.7064C36.5621 35.6298 36.5005 35.5167 36.5433 35.2837C37.2657 31.6128 39.2506 29.2633 41.791 27.8189C44.3533 26.3623 47.5071 25.8139 50.5411 25.829C53.6546 25.8446 57.5906 26.6715 59.924 28.9699L59.9239 28.97L59.9329 28.9784C62.6461 31.5398 62.6147 34.8865 62.5775 38.8518C62.5745 39.1722 62.5714 39.4967 62.5698 39.8251L62.5192 49.9698C62.505 52.8325 63.569 54.3305 64.6065 55.7912C64.7464 55.9882 64.8859 56.1846 65.0222 56.3835L65.028 56.392L65.0341 56.4003C65.1993 56.6239 65.2717 56.8457 65.2758 57.0081C65.2795 57.1546 65.2325 57.2343 65.1558 57.2888Z"
                      stroke="white"
                      stroke-width="1.15593"
                    />
                    <path
                      d="M50.3991 54.82C52.3235 53.0491 52.9442 50.992 53.7536 48.6079L54.206 47.2757C49.7397 45.7592 44.7306 45.1533 42.9451 50.4122C42.0404 53.0767 42.8171 55.3737 45.1898 56.1793C46.9345 56.7717 48.8269 56.2412 50.3991 54.82Z"
                      fill="#2ED19E"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M67.6015 67.7582C63.8895 71.2741 58.1503 73.6069 53.0308 74.2325C45.8586 75.1089 39.105 73.2483 33.6702 69.4445C33.2569 69.1435 33.521 68.6344 34.0241 68.849C39.6667 71.272 46.3948 72.3074 53.1218 71.4854C57.6478 70.9323 62.5287 69.3821 66.8901 66.8662C67.5493 66.5095 68.2088 67.1819 67.6015 67.7582Z"
                      fill="#2ED19E"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M69.0755 65.5888C68.4745 64.9845 65.5737 65.6904 64.2841 66.0237C63.8944 66.1215 63.7779 65.7843 64.1187 65.4917C66.2657 63.5476 70.1596 63.5738 70.6712 64.0635C71.1829 64.5532 71.0855 68.4808 69.108 70.58C68.795 70.8943 68.4554 70.7852 68.5584 70.3961C68.902 69.0991 69.6794 66.2178 69.0755 65.5888Z"
                      fill="#2ED19E"
                    />
                  </svg>

                  <div className="ourserices-list-div2">
                    <h1 className="ourservices-list-text1">Amazon PPC</h1>
                    <HashLink
                      className="ourservices-list-text2"
                      to="#amazon"
                      spy={true}
                      smooth={true}
                      offset={-100}
                      duration={600}>
                      Learn More{" "}
                      <svg
                        className="ml-2"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L15.0711 10.3431C15.4616 9.95262 15.4616 9.31946 15.0711 8.92893C14.6805 8.53841 14.0474 8.53841 13.6569 8.92893L8 14.5858L2.34315 8.92893C1.95262 8.53841 1.31946 8.53841 0.928933 8.92893C0.538408 9.31946 0.538408 9.95262 0.928933 10.3431L7.29289 16.7071ZM7 4.37114e-08L7 16L9 16L9 -4.37114e-08L7 4.37114e-08Z"
                          fill="#22D388"
                        />
                      </svg>
                    </HashLink>
                  </div>
                </div>
              </div>
            </Fade>

            <Fade top distance="4%" duration={1200}>
              <div className="col-lg-6 col-12 ourservices-list-div2 mt-lg-0 mt-5" >
                <div className="row ">
                  <svg
                    className="ourservices-list-svg-1"
                    width="100"
                    height="100"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="50.0788"
                      cy="50.0792"
                      r="47.3121"
                      transform="rotate(-111.759 50.0788 50.0792)"
                      stroke="#414141"
                      stroke-width="4"
                    />
                    <path
                      d="M65.1558 57.2888L65.1445 57.2969L65.1336 57.3054C64.2194 58.0232 62.8912 59.1513 61.7131 60.1519C61.0724 60.696 60.4762 61.2024 60.0151 61.5846C59.7579 61.7978 59.4467 61.8368 59.1643 61.6913C57.443 60.2396 56.8988 59.4266 56.0524 58.1622C55.9052 57.9423 55.7488 57.7087 55.5755 57.4557L55.179 56.8769L54.6868 57.3768C52.9354 59.1554 51.4605 60.2761 49.8933 60.9579C48.3301 61.6379 46.6287 61.9014 44.3916 61.8902C41.7838 61.8772 39.5105 61.0529 37.8962 59.475C36.2862 57.9013 35.2729 55.5207 35.2891 52.2778C35.3144 47.1981 38.0483 43.8519 41.9213 42.1768L41.9219 42.1766C43.6243 41.4383 45.6859 40.9949 47.8172 40.684C49.2542 40.4745 50.6922 40.3288 52.06 40.1903C52.7269 40.1227 53.377 40.0569 54.0023 39.9861L54.5127 39.9283L54.5153 39.4147L54.5193 38.6001C54.5201 38.4329 54.5229 38.2575 54.5258 38.0762C54.5357 37.4518 54.5468 36.7577 54.4829 36.0891C54.3994 35.2168 54.1845 34.3081 53.6291 33.5245C52.6834 32.1324 51.0014 31.5622 49.5544 31.5549C48.2088 31.5482 46.9063 31.8795 45.8563 32.6029C44.801 33.33 44.0317 34.4335 43.7358 35.9026C43.6747 36.1361 43.5772 36.3394 43.4654 36.4729C43.3678 36.5894 43.2853 36.6263 43.2131 36.632L37.0447 35.9446C36.8618 35.8854 36.7167 35.8017 36.631 35.7064C36.5621 35.6298 36.5005 35.5167 36.5433 35.2837C37.2657 31.6128 39.2506 29.2633 41.791 27.8189C44.3533 26.3623 47.5071 25.8139 50.5411 25.829C53.6546 25.8446 57.5906 26.6715 59.924 28.9699L59.9239 28.97L59.9329 28.9784C62.6461 31.5398 62.6147 34.8865 62.5775 38.8518C62.5745 39.1722 62.5714 39.4967 62.5698 39.8251L62.5192 49.9698C62.505 52.8325 63.569 54.3305 64.6065 55.7912C64.7464 55.9882 64.8859 56.1846 65.0222 56.3835L65.028 56.392L65.0341 56.4003C65.1993 56.6239 65.2717 56.8457 65.2758 57.0081C65.2795 57.1546 65.2325 57.2343 65.1558 57.2888Z"
                      stroke="white"
                      stroke-width="1.15593"
                    />
                    <path
                      d="M50.3991 54.82C52.3235 53.0491 52.9442 50.992 53.7536 48.6079L54.206 47.2757C49.7397 45.7592 44.7306 45.1533 42.9451 50.4122C42.0404 53.0767 42.8171 55.3737 45.1898 56.1793C46.9345 56.7717 48.8269 56.2412 50.3991 54.82Z"
                      fill="#2ED19E"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M67.6015 67.7582C63.8895 71.2741 58.1503 73.6069 53.0308 74.2325C45.8586 75.1089 39.105 73.2483 33.6702 69.4445C33.2569 69.1435 33.521 68.6344 34.0241 68.849C39.6667 71.272 46.3948 72.3074 53.1218 71.4854C57.6478 70.9323 62.5287 69.3821 66.8901 66.8662C67.5493 66.5095 68.2088 67.1819 67.6015 67.7582Z"
                      fill="#2ED19E"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M69.0755 65.5888C68.4745 64.9845 65.5737 65.6904 64.2841 66.0237C63.8944 66.1215 63.7779 65.7843 64.1187 65.4917C66.2657 63.5476 70.1596 63.5738 70.6712 64.0635C71.1829 64.5532 71.0855 68.4808 69.108 70.58C68.795 70.8943 68.4554 70.7852 68.5584 70.3961C68.902 69.0991 69.6794 66.2178 69.0755 65.5888Z"
                      fill="#2ED19E"
                    />
                  </svg>

                  <div className="ourserices-list-div2">
                    <h1 className="ourservices-list-text1">Amazon DSP</h1>
                    <HashLink
                      className="ourservices-list-text2"
                      to="#web-design"
                      spy={true}
                      smooth={true}
                      offset={-100}
                      duration={600}>
                      Learn More{" "}
                      <svg
                        className="ml-2"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L15.0711 10.3431C15.4616 9.95262 15.4616 9.31946 15.0711 8.92893C14.6805 8.53841 14.0474 8.53841 13.6569 8.92893L8 14.5858L2.34315 8.92893C1.95262 8.53841 1.31946 8.53841 0.928933 8.92893C0.538408 9.31946 0.538408 9.95262 0.928933 10.3431L7.29289 16.7071ZM7 4.37114e-08L7 16L9 16L9 -4.37114e-08L7 4.37114e-08Z"
                          fill="#22D388"
                        />
                      </svg>
                    </HashLink>
                  </div>
                </div>
              </div>
            </Fade>

            <Fade top distance="4%" duration={1200}>
              <div className="col-lg-6 col-12 ourservices-list-div3 mt-5">
                <div className="row ">
                  <svg
                    className="ourservices-list-svg-1"
                    width="99"
                    height="99"
                    viewBox="0 0 99 99"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="-0.786857"
                      y="0.22124"
                      width="14.5124"
                      height="48.1837"
                      rx="7.25619"
                      transform="matrix(-0.872107 -0.489316 -0.489316 0.872107 58.9184 31.52)"
                      fill="#272727"
                      stroke="white"
                      stroke-width="1.15593"
                    />
                    <rect
                      x="39.7844"
                      y="32.0979"
                      width="14.5124"
                      height="48.1837"
                      rx="7.25619"
                      transform="rotate(-29.2956 39.7844 32.0979)"
                      fill="#272727"
                      stroke="white"
                      stroke-width="1.15593"
                    />
                    <circle
                      cx="33.1688"
                      cy="64.3787"
                      r="7.80255"
                      fill="#2ED19E"
                    />
                    <circle
                      cx="49.6771"
                      cy="49.6774"
                      r="47.3132"
                      transform="rotate(-80.6396 49.6771 49.6774)"
                      stroke="#414141"
                      stroke-width="4"
                    />
                  </svg>

                  <div className="ourserices-list-div2" >
                    <h1 className="ourservices-list-text1">Google Ads</h1>
                    <HashLink
                      className="ourservices-list-text2"
                      to="#google-ads"
                      spy={true}
                      smooth={true}
                      offset={-100}
                      duration={600}
                    >
                      Learn More{" "}
                      <svg
                        className="ml-2"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L15.0711 10.3431C15.4616 9.95262 15.4616 9.31946 15.0711 8.92893C14.6805 8.53841 14.0474 8.53841 13.6569 8.92893L8 14.5858L2.34315 8.92893C1.95262 8.53841 1.31946 8.53841 0.928933 8.92893C0.538408 9.31946 0.538408 9.95262 0.928933 10.3431L7.29289 16.7071ZM7 4.37114e-08L7 16L9 16L9 -4.37114e-08L7 4.37114e-08Z"
                          fill="#22D388"
                        />
                      </svg>
                    </HashLink>
                  </div>
                </div>
              </div>
            </Fade>

            <Fade top distance="4%" duration={1200}>
              <div className="col-lg-6 col-12 ourservices-list-div2 mt-5" >
                <div className="row ">
                  <svg
                    className="ourservices-list-svg-1"
                    width="99"
                    height="99"
                    viewBox="0 0 99 99"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="49.37"
                      cy="49.3697"
                      r="47.3121"
                      transform="rotate(-83.7729 49.37 49.3697)"
                      stroke="#414141"
                      stroke-width="4"
                    />
                    <path
                      d="M59.1542 33.3115L31.4118 49.3286L59.1542 65.3457L59.1542 33.3115Z"
                      stroke="white"
                      stroke-width="1.15593"
                    />
                    <path
                      d="M63.1302 26.3225L23.0412 49.4679L63.1302 72.6133L63.1302 26.3225Z"
                      stroke="white"
                      stroke-width="1.15593"
                    />
                    <path
                      d="M67.9579 69.2489C67.9579 65.9027 65.2163 63.1802 61.8222 63.1802C58.428 63.1802 55.6864 65.9027 55.6864 69.2489C55.6864 72.5951 58.428 75.3175 61.8222 75.3175C65.2163 75.3175 67.9579 72.5951 67.9579 69.2489Z"
                      fill="#272727"
                      stroke="white"
                      stroke-width="1.15593"
                    />
                    <path
                      d="M67.9579 26.9647C67.9579 23.6186 65.2163 20.8961 61.8222 20.8961C58.428 20.8961 55.6864 23.6186 55.6864 26.9647C55.6864 30.3109 58.428 33.0334 61.8222 33.0334C65.2163 33.0334 67.9579 30.3109 67.9579 26.9647Z"
                      fill="#272727"
                      stroke="white"
                      stroke-width="1.15593"
                    />
                    <path
                      d="M31.4116 49.618C31.4116 46.2664 28.6945 43.5494 25.3429 43.5494C21.9913 43.5494 19.2743 46.2664 19.2743 49.618C19.2743 52.9697 21.9913 55.6867 25.3429 55.6867C28.6945 55.6867 31.4116 52.9697 31.4116 49.618Z"
                      fill="#2ED19E"
                      stroke="#2ED19E"
                      stroke-width="1.15593"
                    />
                  </svg>

                  <div className="ourserices-list-div2" >
                    <h1 className="ourservices-list-text1">Social Media</h1>
                    <HashLink
                      className="ourservices-list-text2"
                      to="#social-media"
                      spy={true}
                      smooth={true}
                      offset={-100}
                      duration={600}>
                      Learn More{" "}
                      <svg
                        className="ml-2"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L15.0711 10.3431C15.4616 9.95262 15.4616 9.31946 15.0711 8.92893C14.6805 8.53841 14.0474 8.53841 13.6569 8.92893L8 14.5858L2.34315 8.92893C1.95262 8.53841 1.31946 8.53841 0.928933 8.92893C0.538408 9.31946 0.538408 9.95262 0.928933 10.3431L7.29289 16.7071ZM7 4.37114e-08L7 16L9 16L9 -4.37114e-08L7 4.37114e-08Z"
                          fill="#22D388"
                        />
                      </svg>
                    </HashLink>
                  </div>
                </div>
              </div>
            </Fade>

          </div>
        </div>
      </div>

      {/* section no 2 */}



      {/* section no 2 */}

      <div className="container-fluid service-amazon-div1 pl-0 pr-0" id="amazon">
        <Fade top distance="4%" duration={1200}>
          <img src={amazonimg} className="img-fluid amazon-img-1" />
        </Fade>
        <div className="container service-amazon-div2">
          <Fade top distance="4%" duration={1200}>
            <h1 className="service-amazon-head1">
              Boost Your ROI With The Best Amazon Marketing Strategy
            </h1>
          </Fade>
          <Fade top distance="4%" duration={1200}>
            <p className="service-amazon-para1 mt-5" >
              Our dedicated team of brainers work hard to maximize exposure for your products through ads. The relationships we build with clients are based on results, helping them achieve their Amazon and e-commerce objectives.
            </p>
          </Fade>
          <Fade top distance="4%" duration={1200}>
            <p className="service-amazon-para1 mt-3" >
              In order to achieve client objectives, the company pays close attention to every detail of the Amazon ad campaign, from targeting to creative concepts. With services ranging from lifecycle marketing strategy, PPC management, DSP management and A/B testing, to web analytics, we can help you achieve any desired Amazon marketing outcome.
            </p>
          </Fade>
        </div>

        <div className="container services-ads-div3 d-flex justify-content-center">
          <Fade top distance="4%" duration={1200}>
            <div className="amazon-points-div">
              {/* <div className="col-lg-6 col-12"> */}
              <div className="row mx-auto" >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-amazon-head2 ml-3 my-auto">
                  Account Management
                </h1>
              </div>
              {/* </div> */}

              {/* <div className="col-lg-6 col-12 d-flex justify-content-center mt-lg-0 mt-sm-4 mt-2"> */}
              <div className="row mx-auto mt-sm-4 mt-2" >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-amazon-head2 ml-3 my-auto">
                  Listing Optimizing
                </h1>
              </div>
              {/* </div> */}

              <div className="row mx-auto mt-lg-0 mt-sm-4 mt-2" >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-amazon-head2 ml-3 my-auto">Amazon PPC</h1>
              </div>


              {/* <div className="col-lg-6 col-12 mt-sm-4 mt-2"> */}
              <div className="row mx-auto mt-sm-4 mt-2" >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-amazon-head2 ml-3 my-auto">
                  Amazon DSP
                </h1>
              </div>
              {/* </div> */}
            </div>
          </Fade>
        </div>
        <Fade top distance="4%" duration={1200}>
          <div className="services-ads-btn1-div" >
            <Link to="/contact-us" className="services-ads-btn1">
              Get Your Free Quote Today
            </Link>
          </div>
        </Fade>
      </div>

      {/* section no 3 */}

      <div className="container-fluid service-web-div1 pl-0 pr-0" id="web-design">
        <div className="services-color-svg3"></div>
        <div className="services-color-svg4"></div>
        <Fade top distance="4%" duration={1200}>
          <img src={amazonimg2} className="img-fluid web-img-1 w-100" />
        </Fade>

        <div className="container service-web-div2" >
          <Fade top distance="4%" duration={1200}>
            <h1 className="service-web-head1" >
              Grow Online Sales Through E-Commerce Marketing
            </h1>
          </Fade>
          <Fade top distance="4%" duration={1200}>
            <p className="service-web-para1 mt-5" >
              Our team provides personalised In-depth digital strategies, campaign optimization focused only on business growth, comprehensive audit of current marketing activities and competitor analysis of businesses on online platforms where customers spend most of their time.
            </p>
          </Fade>
        </div>
        <Fade top distance="4%" duration={1200}>
          <div className="services-ads-btn1-div" >
            <Link to="/contact-us" className="services-ads-btn1">
              Get Your Free Quote Today
            </Link>
          </div>
        </Fade>
      </div>




      {/* section #4 */}


      <div className="container-fluid service-ads-div1 pl-0 pr-0" id="google-ads">
        <Fade top distance="4%" duration={1200}>
          <img src={adsimg} className="img-fluid ads-img-1" />
        </Fade>
        <div className="container service-ads-div2">
          <Fade top distance="4%" duration={1200}>
            <h1 className="service-ads-head1" >
              One of the Most Effective Forms of Digital Advertising{" "}
            </h1>
          </Fade>
          <Fade top distance="4%" duration={1200}>
            <p className="service-ads-para1 mt-5" >
              Paid search is a highly effective method of ‘buying’ traffic to your
              website. The name refers to the pricing model, Pay Per Click (PPC).
              You only pay when a person clicks an ad, directing them through to
              your website.
            </p>
          </Fade>
          <Fade top distance="4%" duration={1200}>
            <p className="service-ads-para1" >
              PPC is a fantastic source to drive traffic and increase conversions
              for new and established websites. PPC is exceptionally trackable and
              as a result, it’s very easy to measure how profitable the traffic
              is.
            </p>
          </Fade>
        </div>

        <div className="container services-ads-div3 d-flex justify-content-center">
          <Fade top distance="4%" duration={1200}>
            <div className="services-points-div">
              {/* <div className="col-lg-6 col-12"> */}
              <div className="row mx-auto" >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-ads-head2 ml-3 my-auto">
                  Google Search Ads
                </h1>
              </div>
              {/* </div> */}

              {/* <div className="col-lg-6 col-12 d-flex justify-content-center mt-lg-0 mt-sm-4 mt-2"> */}
              <div className="row mx-auto mt-sm-4 mt-2" >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-ads-head2 ml-3 my-auto">
                  Google Shopping Ads
                </h1>
              </div>
              {/* </div> */}

              {/* <div className="col-lg-6 col-12 mt-sm-4 mt-2"> */}
              <div className="row mx-auto mt-lg-0 mt-sm-4 mt-2" >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-ads-head2 ml-3 my-auto">
                  Google Display Ads
                </h1>
              </div>
              {/* </div> */}

              {/* <div className="col-lg-6 col-12 abd d-flex justify-content-center mt-sm-4 mt-2"> */}
              <div className="row mx-auto mt-sm-4 mt-2 " >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-ads-head2 ml-3 my-auto">Youtube Ads</h1>
              </div>
            </div>
            {/* </div> */}
          </Fade>
        </div>
        <Fade top distance="4%" duration={1200}>
          <div className="services-ads-btn1-div" >
            <Link to="/contact-us" className="services-ads-btn1">
              Get Your Free Quote Today
            </Link>
          </div>
        </Fade>
      </div>




      {/* section #5 */}


      <div className="container-fluid service-social-div1 pl-0 pr-0" id="social-media">
        <div className="services-color-svg3"></div>
        <div className="services-color-svg4"></div>
        <Fade top distance="4%" duration={1200}>
          <img src={socialmediaimg} className="img-fluid social-img-1" />
        </Fade>
        <div className="container service-ads-div2">
          <Fade top distance="4%" duration={1200}>
            <h1 className="service-social-head1" >
              Reach millions of your potential customers in the medium they use{" "}
            </h1>
          </Fade>
          <Fade top distance="4%" duration={1200}>
            <p className="service-social-para1 mt-5" >
              Social media is a range of websites and apps that allow individuals,
              communities, and businesses to share content with each other and
              engage in social networking.
            </p>
          </Fade>
          <Fade top distance="4%" duration={1200}>
            <p className="service-social-para1 mt-3" >
              As a marketing channel, social media is a highly effective way to
              elevate your brand and drive new business. It’s one of the best ways
              to grow and engage with your audience – it’s where potential
              customers spend their time and often where they make their
              decisions, so you can’t afford to be absent.
            </p>
          </Fade>
        </div>

        <div className="container services-ads-div3 d-flex justify-content-center">
          <Fade top distance="4%" duration={1200}>
            <div className="social-points-div">
              {/* <div className="col-lg-6 col-12"> */}
              <div className="row mx-auto" >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-social-head2 ml-3 my-auto">
                  Facebook Ads
                </h1>
              </div>
              {/* </div> */}

              {/* <div className="col-lg-6 col-12 d-flex justify-content-center mt-lg-0 mt-sm-4 mt-2"> */}
              <div className="row mx-auto mt-lg-0 mt-sm-4 mt-2" >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-social-head2 ml-3 my-auto" >
                  Instagram Ads
                </h1>
              </div>
              {/* </div> */}

              {/* <div className="col-lg-6 col-12 mt-sm-4 mt-2"> */}
              <div className="row mx-auto mt-lg-0 mt-sm-4 mt-2" >
                <svg
                  className="my-auto"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.9444"
                    cy="10.4495"
                    r="8"
                    transform="rotate(-35.4072 10.9444 10.4495)"
                    stroke="#19E7A7"
                    stroke-width="4"
                  />
                </svg>
                <h1 className="service-social-head2 ml-3 my-auto">
                  Organic Social Media
                </h1>
              </div>
              {/* </div> */}
            </div>
          </Fade>
        </div>

        <Fade top distance="4%" duration={1200}>
          <div className="services-ads-btn1-div" >
            <Link to="/contact-us" className="services-ads-btn1">
              Get Your Free Quote Today
            </Link>
          </div>
        </Fade>
      </div>

      {/* last section */}

      <div className="services-last-div">
        <div className="container">
          <Fade top distance="4%" duration={1200}>
          <h1 className="last-text1" >
            RIGHT N
            <span>
              <svg
                className="service-last-svg"
                width="131"
                height="105"
                viewBox="0 0 131 105"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M98.5822 64.0627C70.4823 13.0906 47.5365 4.62382 0.673609 2.67836"
                  stroke="url(#paint0_linear_345_66)"
                  stroke-width="5"
                />
                {/* <circle cx="108.092" cy="82.843" r="20.1277" transform="rotate(-168.508 108.092 82.843)" stroke="#909090" stroke-width="4"/> */}
                <defs>
                  <linearGradient
                    id="paint0_linear_345_66"
                    x1="2.71146"
                    y1="-3.95807"
                    x2="109.542"
                    y2="22.1805"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#2ED19E" />
                    <stop offset="1" stop-color="#1D8665" />
                  </linearGradient>
                </defs>
              </svg>
              O
            </span>
            W
          </h1>
          </Fade>
          <Fade top distance="4%" duration={1200}>
          <p className="last-text2 mt-5" >
            we’re just taking on 6 new clients per month. That’s so we can
            deliver on our guarantee of giving every campaign all we’ve got. No
            distractions. Just a focus on making your business the best.
          </p>
          </Fade>
          <Fade top distance="4%" duration={1200}>
          <p className="last-text2 mt-3" >
            The spots won’t be around for long – so get in touch with us today!
            Our specialists are waiting to transform your business.
          </p>
          </Fade>
        </div>
      </div>
    </div>
  );
}

export default Services;
